/** A report's filters, kept in the URL so a drill-down or a filtered report can be shared or reloaded. */
export type ReportSearch = Partial<Record<(typeof KEYS)[number], string>>;

const KEYS = [
  "from",
  "to",
  "locationId",
  "channel",
  "staffId",
  "groupBy",
  "days",
  "kind",
  "categoryId",
  "variantId",
  "status",
] as const;

export function reportSearch(search: Record<string, unknown>): ReportSearch {
  const out: ReportSearch = {};
  for (const key of KEYS) {
    const value = search[key];
    if (typeof value === "string" && value.trim() !== "") out[key] = value.trim().slice(0, 64);
  }
  return out;
}
